import { ISelectedFilterBody, ModulesType } from '../models/TableFilterModels';

const PREFIX: string = 'filters-';
const getKeyLocalStorage = (module: ModulesType, editable: boolean) => {
	const suffix = editable ? '_EDITED' : '';
	return PREFIX + module + suffix;
};
export const setLocalStorageFilter = (
	module: ModulesType,
	editable: boolean,
	newSet: any
): void => {
	if (newSet) {
		window.localStorage.setItem(
			getKeyLocalStorage(module, editable),
			JSON.stringify(newSet)
		);
	}
};

export const getLocalStorageFilter = (
	module: ModulesType,
	editable: boolean
): ISelectedFilterBody[] => {
	const localStorageFilter: string | null = window.localStorage.getItem(
		getKeyLocalStorage(module, editable)
	);
	if (localStorageFilter) {
		return JSON.parse(localStorageFilter);
	}

	return [];
};

export const clearLocalStorageFilter = (
	module: ModulesType,
	editable: boolean
): void => {
	localStorage.removeItem(getKeyLocalStorage(module, editable));
};

export const clearLocalStorageFilters = () => {
	const modules: ModulesType[] = [
		'venda',
		'oportunidade',
		'carteiraPedido',
		'horaHora',
		'forecastDemanda',
		'estoque',
		'orcamento',
		'hierarquia',
		'acuracidade',
		'membro',
		'clienteRelacionamento',
		'restricted-plan',
		'collaboration',
		'consensus',
	];
	modules.forEach(module => {
		clearLocalStorageFilter(module, false);
		clearLocalStorageFilter(module, true);
	});
};
